import balancesReducer from '@/entities/balances/model/slice'
import banksReducer from '@/entities/banks/model/slice'
import ratesReducer from '@/entities/exchangeRates/model/slice'
import merchantReducer from '@/entities/merchant/model/slice'
import traderReducer from '@/entities/trader/model/slice'

import { Action, combineReducers, configureStore } from '@reduxjs/toolkit'

const appReducer = combineReducers({
  trader: traderReducer,
  merchant: merchantReducer,
  balances: balancesReducer,
  banks: banksReducer,
  rates: ratesReducer,
})

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: Action) => {
  if (action.type === 'RESET_STATE') {
    state = undefined
  }
  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
